import Vue from 'vue'
import Vuex from 'vuex'

import url from '../util/url'

import VuexPersistence from 'vuex-persist'
import * as getters from './getter'

import goodsclass from './modules/goodsclass'// 商品分类
import goodsdetail from './modules/goodsdetail'// 商品详情
import pointsgoods from './modules/pointsgoods'// 积分商品
import homesearch from './modules/homesearch'// 搜索
import homecart from './modules/homecart'// 购物车
import distributor from './modules/distributor'// 配送员
import member from './modules/member'// 用户信息
import seller from './modules/seller'// 卖家信息
import fuwu from './modules/fuwu'// 服务人员信息
import config from './modules/config'// 配置信息
import chatroom from './modules/chatroom' // 聊天室
import store from './modules/store' // 商店
import modal from './modules/modal' // modal

Vue.use(Vuex)

let prefix = 'dso2o'

if (url.is('^/home/') || url.is('^/member/')) {
  prefix += ':member'
} else if (url.is('^/distributor/')) {
  prefix += ':distributor'
} else if (url.is('^/seller/')) {
  prefix += ':seller'
} else if (url.is('^/fuwu/')) {
  prefix += ':fuwu'
}

const vuexLocal = new VuexPersistence({
    prefix,
    modules: ['distributor', 'member', 'seller', 'fuwu', 'config', 'homecart', 'goodsdetail', 'pointsgoods'],
    storage: window.localStorage
})

export default new Vuex.Store({
  modules: {
    homesearch,
    homecart,
    goodsclass,
    goodsdetail,
    pointsgoods,
    distributor,
    member,
    seller,
    fuwu,
    config,
    chatroom,
    store,
    modal
  },
  getters,
  plugins: [
    vuexLocal.plugin
  ]
})
